"use strict";
/**
 * bridge 是和app交互的方法
 * **/

function setupWebViewJavascriptBridge(callback) {
    if (window.WebViewJavascriptBridge) {
        return callback(window.WebViewJavascriptBridge);
    } else {
        document.addEventListener(
            "WebViewJavascriptBridgeReady",
            function() {
                return callback(window.WebViewJavascriptBridge);
            },
            false
        );
    }

    if (window.WebViewJavascriptBridge) {
        return callback(window.WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement("iframe");
    WVJBIframe.style.display = "none";
    WVJBIframe.src = "wvjbscheme://__BRIDGE_LOADED__";
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function() {
        document.documentElement.removeChild(WVJBIframe);
    }, 0);
}

export function callHandler(CMD, params) {
    return new Promise(function(resolve) {
        setupWebViewJavascriptBridge(function(bridge) {
            bridge["callHandler"](CMD, params, function(resStr) {
                if (Object.prototype.toString.call(resStr) !== "[object String]") {
                    resStr = JSON.stringify(resStr);
                }
                //res 是个字符串
                resolve(resStr);
            });
        });
    });
}

export function registerHandler(CMD) {
    return new Promise(function(resolve) {
        setupWebViewJavascriptBridge(function(bridge) {
            bridge["registerHandler"](CMD, function(resStr) {
                if (Object.prototype.toString.call(resStr) !== "[object String]") {
                    resStr = JSON.stringify(resStr);
                }
                //res 是个字符串
                resolve(resStr);
            });
        });
    });
}

/**
 * 获取 数据 签名 ，token等信息
 * data 是要封装的数据
 * isEncrypt 数据是否要加密
 *
 * 返回的是 promise
 * **/
export function signData(data, isEncrypt) {
    if (Object.prototype.toString.call(data) !== "[object Object]") {
        return Promise.resolve({});
    }
    let isAes = isEncrypt ? "1" : "0";
    return callHandler("xhReqDataHandle", {
        reqDataJson: JSON.stringify(data),
        isAes: isAes
    });
}

/**
 * 获取用户信息 token  userId managerId
 * **/
export function getUserInfo() {
    return registerHandler("xhUserInfoToWeb").then(function(data) {
        data = JSON.parse(data);
        return Promise.resolve(data);
    });
}
/**
 * 分享功能
 * {
 *   "shareType": "",
 *   "shareTitle": "",
 *   "shareContent": "",
 *  "shareImageUrl": "",
 *   "shareUrl": ""
 * }
 *
 * **/
export function share(params) {
    const options = {};
    Object.assign(options, params);
    return callHandler("xhShareSocialPlatform", options);
}
export function shareHeaderBtn(params) {
    const options = {};
    Object.assign(options, params);
    return callHandler("xhShowButton", options);
}
/**
 * 下载图片
 * **/
export function downloadFile(params) {
    const options = {};
    Object.assign(options, params);
    return callHandler("xhDownload", options);
}
/**
 * 设置页面title
 * **/
export function setTitle(titleStr) {
    return callHandler("xhWebTitle", titleStr);
}
/**
 * h5通过app跳转到别的h5,  参数复制 要深复制
 * **/
export function bridgeRedirect(url, params) {
    const options = {};
    if (typeof url === "object") {
        params = url;
        url = "";
    }
    Object.assign(
        options,
        {
            page: "webview",
            pageParams: {
                url: url,
                login: "1"
            }
        },
        params
    );
    return callHandler("xhH5GoAppPages", options);
}

/**
 * h5跳转app
 * **/
export function redirectApp(appPage, params) {
    let options = {
        page: appPage,
        pageParams: params
    };
    return callHandler("xhH5GoAppPages", options);
}

/**
 * 账单分享、截屏
 * **/

